import { themeAtom } from "../atoms";
import { useAtomValue } from "jotai";
import { InputHTMLAttributes, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type InputType = "text" | "number";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  placeholder?: string;
  suffix?: ReactNode;
  type?: InputType;
  error?: string;
  dataTest?: string;
  topLabel?: ReactNode | string;
  bottomLabel?: ReactNode | string;
  className?: string;
}

const Input: React.FC<Props> = ({
  type = "text",
  placeholder,
  suffix,
  error,
  dataTest,
  topLabel,
  bottomLabel,
  className,
  ...restProps
}) => {
  const theme = useAtomValue(themeAtom);

  return (
    <>
      {topLabel && <div className={`mb-2 block text-sm`}>{topLabel}</div>}

      <div data-test={dataTest} className="relative inline-flex w-full">
        <input
          type={type}
          className={twMerge(
            `h-[48px] w-full rounded-lg border px-4`,
            `font-['Be Vietnam Pro'] text-sm focus:outline-none`,
            `${suffix && "rounded-br-none rounded-tr-none"}`,
            `${error ? "border border-red-600" : theme.uwhcAssistant.border}`,
            `${className}`,
          )}
          placeholder={placeholder}
          {...restProps}
        />
        {suffix ? (
          <div
            className={twMerge(
              "flex items-center rounded-r border-y border-r px-3 py-2",
              theme.uwhcAssistant.border,
              theme.balticQuestionnaire.grayBg,
              error ? "border-red-600" : theme.uwhcAssistant.border,
            )}
          >
            {suffix}
          </div>
        ) : null}
      </div>

      {bottomLabel && <div className={`mt-1 block h-4 text-xs`}>{bottomLabel}</div>}

      {error ? (
        <div className={`mt-1 block h-4 text-xs text-red-600`}>{error}</div>
      ) : (
        <div className={"mt-1 h-4 text-xs opacity-0"} />
      )}
    </>
  );
};

export default Input;
